import { LegendWithOneLineCheckboxFlex } from "@similarweb/ui-components";

import type { LegendItemProps } from "./types";
import { formatNumber } from "./utils/formatNumber";

export const FormattedLegendItem = ({ value, ...other }: LegendItemProps) => {
    const formattedValue = formatNumber(value);

    return (
        <LegendWithOneLineCheckboxFlex
            {...other}
            value={formattedValue.toString()}
        />
    );
};
